import { Link, useLocation } from "react-router-dom";

export default function MobileStickyCTA() {
  const { pathname } = useLocation();
  if (pathname === "/book") return null;
  return (
    <div className="lg:hidden fixed bottom-3 left-3 right-3 z-40">
      <div className="flex items-center gap-2 p-2 rounded-2xl bg-primary-900/95 backdrop-blur-md border border-primary-800">
        <a
          href="tel:+447700900123"
          aria-label="Call local electrician"
          className="w-12 h-12 flex items-center justify-center rounded-xl bg-background-50/10 text-background-50 hover:bg-background-50/15 transition-colors cursor-pointer"
        >
          <i className="ri-phone-fill text-lg"></i>
        </a>
        <a
          href="https://wa.me/447700900123"
          aria-label="Message on WhatsApp"
          className="w-12 h-12 flex items-center justify-center rounded-xl bg-background-50/10 text-background-50 hover:bg-background-50/15 transition-colors cursor-pointer"
        >
          <i className="ri-whatsapp-line text-lg"></i>
        </a>
        <Link
          to="/book"
          className="flex-1 h-12 flex items-center justify-center gap-2 rounded-xl bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          Book Local Electrician
          <i className="ri-arrow-right-up-line"></i>
        </Link>
      </div>
    </div>
  );
}